import PropTypes from 'prop-types';
import { XMarkIcon } from '@heroicons/react/24/outline';
import InputBase from '@/components/core/form/InputBase';

const DraftPropertyRow = ({
  label,
  numeratorValue,
  denominatorValue,
  unitOptions,
  unitOptionsLoading,
  onLabelChange,
  onNumeratorChange,
  onDenominatorChange,
  onCreate,
  onCancel,
  isCreating,
}) => {
  return (
    <div className="rounded-xl border border-gray-200 p-4">
      <div className="flex items-center gap-3">
        <InputBase
          value={label}
          onChange={event => onLabelChange(event.target.value)}
          placeholder="Property label"
          className="!w-[46%]"
        />
        <select
          value={numeratorValue}
          onChange={event => onNumeratorChange(event.target.value)}
          disabled={unitOptionsLoading || isCreating}
          className="select select-sm select-bordered !w-40"
        >
          <option value="">{unitOptionsLoading ? 'Loading units...' : 'Select unit'}</option>
          {unitOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="text-2xl text-gray-400">/</span>
        <select
          value={denominatorValue}
          onChange={event => onDenominatorChange(event.target.value)}
          disabled={unitOptionsLoading || isCreating}
          className="select select-sm select-bordered !w-40"
        >
          <option value="">—</option>
          {unitOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button type="button" className="btn btn-sm btn-accent" disabled={isCreating} onClick={onCreate}>
          {isCreating ? 'Saving...' : 'Create'}
        </button>
        <button type="button" className="btn btn-square btn-sm btn-ghost" disabled={isCreating} onClick={onCancel}>
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

DraftPropertyRow.propTypes = {
  label: PropTypes.string.isRequired,
  numeratorValue: PropTypes.string.isRequired,
  denominatorValue: PropTypes.string.isRequired,
  unitOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  unitOptionsLoading: PropTypes.bool.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onNumeratorChange: PropTypes.func.isRequired,
  onDenominatorChange: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isCreating: PropTypes.bool.isRequired,
};

export default DraftPropertyRow;
